import React, { ReactNode } from 'react'

import { Div, Layout } from '@driftt/tide-core'

import AppNavigationHeader from 'components/app/AppNavigationHeader'
import ConversationResultsSliderContainer from 'components/app/ConversationResultsSliderContainer'
import ReportsCompoundFilterBar, {
  IReportFilterBarProps,
} from 'components/ReportsCompoundFilter'
import useAvailableFilters from 'hooks/useAvailableFilters'
import useReportCount from 'hooks/useReportCount'
import { ReportPage } from 'types/pages'
interface IProps extends IReportFilterBarProps {
  children: ReactNode
  extraContent: ReactNode | null
}

const ReportsLayout = ({
  children,
  reportType,
  showAdvancedFilters,
  showReportFilterBar,
  showDatePicker,
  extraContent,
}: IProps) => {
  const reportAmounts = useReportCount(reportType)
  const availableFilterableEntities = useAvailableFilters({
    reportType,
    showAdvancedFilters,
  })

  return (
    <ConversationResultsSliderContainer>
      <Div className="reports-layout">
        <AppNavigationHeader
          showDatePicker={showDatePicker}
          extraContent={extraContent}
        />
        {showReportFilterBar && (
          <Div className="reports-compound-filter-bar">
            <ReportsCompoundFilterBar
              reportAmounts={reportAmounts}
              availableFilterableEntities={availableFilterableEntities}
              reportType={reportType}
            />
          </Div>
        )}
        <Layout className="fixed">{children}</Layout>
      </Div>
    </ConversationResultsSliderContainer>
  )
}

export const withReportsLayout =
  (
    reportType: ReportPage,
    showAdvancedFilters = false,
    showReportFilterBar = true,
    showDatePicker = true,
    extraContent: React.ReactNode = null
  ) =>
  (Component) =>
    function Layout(props) {
      return (
        <ReportsLayout
          reportType={reportType}
          showAdvancedFilters={showAdvancedFilters}
          showReportFilterBar={showReportFilterBar}
          showDatePicker={showDatePicker}
          extraContent={extraContent}
        >
          <Component {...props} />
        </ReportsLayout>
      )
    }

export default ReportsLayout
